import { HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import {
  AuthHttpHeaderService,
  AuthRedirectService,
  AuthService,
  AuthStorageService,
  AuthToken,
  GlobalMessageService,
  GlobalMessageType,
  OAuthLibWrapperService,
  OccEndpointsService,
  RoutingService,
  WindowRef
} from '@spartacus/core'
import { CookieService } from 'ngx-cookie-service'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class EbAuthHttpHeaderService extends AuthHttpHeaderService {
  constructor(
    authService: AuthService,
    authStorageService: AuthStorageService,
    oAuthLibWrapperService: OAuthLibWrapperService,
    routingService: RoutingService,
    occEndpoints: OccEndpointsService,
    protected globalMessageService: GlobalMessageService,
    authRedirectService: AuthRedirectService,
    protected cookieService: CookieService,
    protected router: Router,
    protected winRef: WindowRef
  ) {
    super(
      authService,
      authStorageService,
      oAuthLibWrapperService,
      routingService,
      occEndpoints,
      globalMessageService,
      authRedirectService
    )
  }

  static userInflictedLogout = false

  get accessToken() {
    return (
      this.cookieService.get('access_token') ||
      this.cookieService.get('temp_customer_emulation_token')
    )
  }

  alterRequest(request: HttpRequest<any>): HttpRequest<any> {
    const hasAuthorizationHeader = !!this.getAuthorizationHeader(request)
    const isOccUrl = this.isOccUrl(request.url)
    if (!hasAuthorizationHeader && isOccUrl && !this.isI18nRequest(request)) {
      return request.clone({
        setHeaders: {
          ...this.createAuthorizationHeader()
        }
      })
    }
    return request
  }

  protected isI18nRequest(request: HttpRequest<any>): boolean {
    return /\/i18n\/[^/]+\/assets\/chunks\//.test(request.url)
  }

  protected createAuthorizationHeader(asmToken?: AuthToken): { Authorization: string } | {} {
    const accessToken = this.accessToken?.trim()
    const asmAccessToken = asmToken?.access_token?.trim()

    if (accessToken) {
      return {
        Authorization: `Bearer ${accessToken}`
      }
    } else if (asmAccessToken) {
      return {
        Authorization: `Bearer ${asmAccessToken}`
      }
    }
    return {}
  }

  /**
   * overwritten to change redirect from login to homepage
   */
  public handleExpiredRefreshToken(): void {
    if (!EbAuthHttpHeaderService.userInflictedLogout) {
      EbAuthHttpHeaderService.userInflictedLogout = /[?&]logout=true\b/.test(
        this.winRef.location.search
      )
    }
    this.authService
      .isUserLoggedIn()
      .pipe(take(1))
      .subscribe(isUserLoggedIn => {
        if (isUserLoggedIn) {
          this.authService.logout()
          if (!EbAuthHttpHeaderService.userInflictedLogout) {
            this.showGlobalSessionExpiredMessage()
          }
        }
      })
  }

  private showGlobalSessionExpiredMessage() {
    this.globalMessageService.add(
      {
        key: 'httpHandlers.sessionExpired'
      },
      GlobalMessageType.MSG_TYPE_ERROR
    )
  }
}
